import { Tooltip } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import '../LayerProperties/LayerProperties.scss';

interface HintLabelProps {
  label: React.ReactNode;
  hint: React.ReactNode;
  /** Typography is the caller's — the base class only handles icon layout. */
  className?: string;
  placement?: TooltipPlacement;
}

const HintLabel: React.FC<HintLabelProps> = ({ label, hint, className, placement = 'topLeft' }) => (
  <span className={['lp-hint-label', className].filter(Boolean).join(' ')}>
    {label}
    <Tooltip title={hint} overlayClassName="lp-hint-tooltip" placement={placement} arrow={false}>
      <span className="lp-hint-label__icon">
        <AiOutlineInfoCircle />
      </span>
    </Tooltip>
  </span>
);

export default HintLabel;
